import { ReactElement, useState } from 'react'
import { EuiButton } from '@equipmentshare/ds2'
import { SelectedPickOrderRow } from '../useFulfillmentOrderPickSelection'
import CreatePickOrderDialog from './CreatePickOrderDialog'

export type CreatePickOrderActionProps = {
	fulfillingInventoryId: string | null,
	/** The checked orders, anchor first. */
	orders: SelectedPickOrderRow[],
}

/**
 * Turning a table selection into a pick order.
 *
 * Sits in the fulfillment orders table's action slot rather than on each row: a
 * run is usually several orders, and a per-row button made the common case the
 * awkward one — start from one order, then find the rest again in a dialog.
 *
 * It stays visible while nothing is checked, disabled, so the gesture announces
 * itself before anyone has guessed the checkboxes lead somewhere.
 */
export default function CreatePickOrderAction( {
	fulfillingInventoryId,
	orders,
}: CreatePickOrderActionProps ): ReactElement | null {
	const [ dialogOpen, setDialogOpen ] = useState( false )

	if ( !fulfillingInventoryId ) {
		return null
	}

	return (
		<>
			<EuiButton
				fill
				disabled={orders.length === 0}
				onClick={() => setDialogOpen( true )}
			>
				Create pick order ({orders.length})
			</EuiButton>
			{dialogOpen && (
				<CreatePickOrderDialog
					open
					onClose={() => setDialogOpen( false )}
					fulfillingInventoryId={fulfillingInventoryId}
					orders={orders}
					// The anchor speaks for the run: every other order was offered only
					// because inventory-api said it shares this destination.
					destinationDescription={orders[ 0 ]?.destinationDescription ?? null}
				/>
			)}
		</>
	)
}
